export const borders = {
  none: 0,
  "0.5px": "0.5px solid",
  "1px": "1px solid",
  "1.5px": "1.5px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid",
}
